module.exports = __webpack_public_path__ + "img/jpg.da8970ee.png";